<template>
    <div class="katalog">
        <div class="box p-3">
            <img :src="image" class="img-fluid" :alt="title" :title="title">
            <div class="h3 mt-3">
                {{ title }}
            </div>
            <div v-html="desc" class="text-cuttet">
            </div>
            <div class="download-box">
                <div class="btn btn-primary btn-block" @click="openModal(uuid)">
                    {{ $translate('Woerner::Template.globalDownload') }}
                </div>
            </div>
        </div>
        <!-- Modal -->
        <div class="modal fade" :id="'katalog_'+uuid" tabindex="-1" :aria-labelledby="title" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title">{{ title }}</h3>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <table class="table">
                            <tbody>
                                <tr v-for="page in pagesList">
                                    <td>
                                        {{ page.katalogseite }}
                                    </td>
                                    <td>
                                        <a :href="page.link" target="_blank" class="d-block btn btn-outline-primary">
                                            <i class="fa fa-file-pdf-o"></i> {{ $translate('Woerner::Template.globalDownload') }}
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" data-dismiss="modal">{{ $translate('Woerner::Template.globalClose') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default
    {
        props:
        {
            uuid:
            {
              type:String,
              default:""
            },
            pages:
            {
                type: Array,
                default: []
            },
            image:
            {
                type:String,
                default:""
            },
            desc:
            {
                type:String,
                default:""
            },
            title:
            {
                type:String,
                default:""
            }
        },
        data: function()
        {
            return {
                onloadVarId: ""
            }
        },
        methods:
        {
            openModal:function (uuid)
            {
              //console.log('uid',uuid);
                $('#katalog_'+uuid).modal('show');
            }
        },
        computed:
        {
           pagesList:function()
           {
               return this.pages;
           }

        }
    }
</script>
